import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
`;

export const Spacer = styled.div`
  height: 75px;
`;

export const Loader = styled.div`
  align-items: center;
  display: flex;
  height: 180px;
  justify-content: center;
  position: relative;
  transform-style: preserve-3d;
  transform: perspective(500px) rotateX(45deg);
  width: 180px;

  span {
    position: absolute;
    display: block;
    border: 15px solid #fff;
    box-sizing: border-box;
    border-radius: 50%;
    box-shadow: 0 10px 0 #e0e0e0, inset 0 10px 0 #e0e0e0;
  }

  span:nth-child(1) {
    height: 100%;
    width: 100%;
    animation: animate1 2s ease-in-out infinite;
  }

  span:nth-child(2) {
    height: 35%;
    width: 35%;
    animation: animate2 2s ease-in-out infinite;
  }

  @keyframes animate1 {
    0% {
      transform: translateZ(-100px);

      height: 100%;
      width: 100%;
    }
    25% {
      transform: translateZ(100px);

      height: 100%;
      width: 100%;
    }
    50% {
      transform: translateZ(100px);

      height: 35%;
      width: 35%;
    }
    75% {
      transform: translateZ(-100px);

      height: 35%;
      width: 35%;
    }
    100% {
      transform: translateZ(-100px);

      height: 100%;
      width: 100%;
    }
  }

  @keyframes animate2 {
    0% {
      transform: translateZ(100px);

      height: 35%;
      width: 35%;
    }
    25% {
      transform: translateZ(-100px);

      height: 35%;
      width: 35%;
    }
    50% {
      transform: translateZ(-100px);

      height: 100%;
      width: 100%;
    }
    75% {
      transform: translateZ(100px);

      height: 100%;
      width: 100%;
    }
    100% {
      transform: translateZ(100px);

      height: 35%;
      width: 35%;
    }
  }

  @keyframes animate4 {
    0% {
      transform: translateZ(-100px);

      height: 100%;
      width: 100%;
    }
    25% {
      transform: translateZ(100px);

      height: 100%;
      width: 100%;
    }
    50% {
      transform: translateZ(100px);

      height: 35%;
      width: 35%;
    }
    75% {
      transform: translateZ(-100px);

      height: 35%;
      width: 35%;
    }
    100% {
      transform: translateZ(-100px);

      height: 100%;
      width: 100%;
    }
  }
`;
